import BaseContacts from './BaseContacts';

export { type BaseContactsProps } from './BaseContacts';
export default BaseContacts;
